import phones from './phones.json'

export default ({ countryCode = 'EG', phoneNumber }) => {
  let prefix = ''
  if (phones[countryCode]) {
    prefix = `+${  phones[countryCode]}`
  } else {
    prefix = '+20'
  }
  return `${prefix  } ${  phoneNumber.replaceAll(prefix, '').replaceAll('tel:', '')}`
}